<form class="form"
      [formGroup]="answerForm"
      (ngSubmit)="onSubmit($event)">
  <mat-form-field>
    <mat-label>Ответ</mat-label>
    <textarea matInput formControlName="text"
              (keydown)="onKeyDown($event)"
              placeholder="Введите ответ"
              #txtarea
              cdkTextareaAutosize
              cdkAutosizeMinRows="2"
              cdkAutosizeMaxRows="5"></textarea>
  </mat-form-field>
  <mat-form-field *ngIf="selectableOptions.length > 0" class="blocked-options">
    <mat-label>Блокируемые ответы</mat-label>
    <mat-select formControlName="blockedOptionIds" multiple
                placeholder="Выберите ответы для блокировки">
      <mat-option *ngFor="let option of selectableOptions" [value]="option.id">
        {{option.text}}
      </mat-option>
    </mat-select>
    <mat-hint>Выбранные ответы будут автоматически сниматься при выборе этого варианта.</mat-hint>
  </mat-form-field>
  <button mat-icon-button
          matTooltip="Добавить ответ"
          type="submit">
    <mat-icon>add</mat-icon>
  </button>
</form>
